<template>
<div class="homeWrapper">
  <PageWrapper id="pageWrapper">
    <transition-group name="chatList" tag="p">
      <QCard
        v-for="(item, ix) in homeChat"
        :key="`item-trans-home-${ix}`"
        :content="item.content"
      />
    </transition-group>
  </PageWrapper>
  <ShareWrapper></ShareWrapper>
</div>
</template>

<script>
import CONFIG from "@/utils/config";
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";
import QCard from "@/components/QCard";
import { mapState, mapActions, mapMutations } from "vuex";
import PageWrapper from "@/components/PageWrapper";
import { View16, View17, View18 } from "@/components/View/index";
import { parseData, objBlurFun, getBaiduLocation } from "@/utils/utils";
import ShareWrapper from "@/components/ShareWrapper.vue";
export default {
  name: "home",
  data() {
    return {
      initTimer: null,
    };
  },
  components: {
    QCard,
    PageWrapper,
    View16,
    View17,
    View18,
    ShareWrapper
  },
  computed: {
    ...mapState([
      "isApp",
      "topicData",
      "userinfo",
   
      "serverTime",
      "pageLoading",
      "isImmerse",
      "shareData",
      "versionSize",
      "homeChat",
      "readNewsId",
      "isClearInitTimer",
      "device",
      "isToastShow",
    ]),
  },
  created() {},
  watch: {
    homeChat(val) {},

    isClearInitTimer: {
      handler(value, o) {
        if (value) {
          clearInterval(this.initTimer);
        } else {
          // this.initTimer = this.getInterData();
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.getInterData();
    this.share();
    document.body.className = "home-body";
    // document.querySelector(".loading-wrap").style.display = "none";
    this.setPageLoadingAsync(false);
    objBlurFun(this.device, "input");
  },
  destroyed() {
    this.setHomeData([]);
    clearTimeout(this.initTimer);
  },
  methods: {
    ...mapMutations([
      "contactDisData",
      "setHomeData",
      "setClearTimer",
      "contactDisData",
      "chatDisData",
    ]),
    ...mapActions([
   
      "getUserInfoAsync",
      "setPageLoadingAsync",
      "fetchHome",
      "fetchNotice",
      "setNoInfo",
      "queryTourism",
      "queryAudio",
    ]),

    share() {
      let ShareData = JSON.parse(JSON.stringify(this.shareData));
      ShareData.callback = function(ret) {
      };
      COVER.share(ShareData);
    },
    getInterData() {
      let that = this;
      this.initTimer = setTimeout(function() {
        that.setNoInfo();
      }, 5000);
    },
  },
};
</script>

<style lang="less">
.homeWrapper{
    width: 100%;
        height: 100%;
        position: relative;
    .PageWrapper{
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 3;
    }
    
}
.chatList-item {
  display: inline-block;
  margin-right: 10px;
}

/*.chatList-enter-active,*/
/*.chatList-leave-active {*/
/*    transition: all 1s;*/
/*}*/
.chatList-enter-active {
  transition: all 0.4s;
}

.chatList-leave-active {
  transition: all 0s;
}

.chatList-enter,
.chatList-leave-to {
  /*opacity: 0;*/
  transform: translateX(50px);
}
</style>
